/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCompany, getCompany } from "../../../../reducers/companySlice";
import {
  createToteat,
  deleteToteat,
  getAllToteat,
  updateToteat,
} from "../../../../utils/services/company";
import { useDispatch } from "react-redux";
import {
  selectLoadingUI,
  loadingOn,
  loadingOff,
} from "../../../../reducers/uiSlice";
import { Notification } from "../../../../containers/notification";
import { useSnackbar } from "notistack";
import {
  selectChangesDeposit,
  setChanges,
} from "../../../../reducers/depositSlice";
import { useChangeRecord } from "../../../../utils/hooks/useChangeRecord";
import { useNavigate } from "react-router-dom";

// CSS

import styles from "./styles.module.css";

//MATERIAL
import Toolbar from "../../../card/toolbar";
import jwt from "jsonwebtoken";
import config from "../../../../utils/config";
import { selectSubsidiaries } from "../../../../reducers/subsidiarySlice";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Alert } from "@material-ui/lab";
import classNames from "classnames";
import ScrollBar from "../../../scrollBar";
import ChangeLogs from "../../../changeLogs/changeLogs";

const logo =
  "https://luma-photos.s3.amazonaws.com/toteat-black-4k.e34ff285.png";

export default function ToteatComponent() {
  const [updated, setUpdated] = useState(false);
  const [subsidiaryId, setSubsidiaryId] = useState();

  const subsidiaries = useSelector(selectSubsidiaries);
  const company = useSelector(selectCompany);
  const loading = useSelector(selectLoadingUI);
  const changes = useSelector(selectChangesDeposit);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [toteatCredentials, setToteatCredentials] = useState([]);
  const [newTokensFlag, setNewTokensFlag] = useState(false);
  const [tokenModifiedFlag, setTokenModifiedFlag] = useState(false);
  const { recordChange } = useChangeRecord();

  const decodeIfJwt = (value) => {
    try {
      if (typeof value === "string" && value.startsWith("ey")) {
        // verify first (checks signature and expiration)
        return jwt.verify(value, config.jwtSecret);
      }
      return value;
    } catch (err) {
      // fallback to simple decode (no signature check)
      try {
        return jwt.decode(value);
      } catch {
        return value;
      }
    }
  };

  const decodeCredentials = (credentials) => {
    const tokenFields = [
      "restaurantId",
      "localId",
      "userId",
      "token",
      "paymentType",
    ];

    return credentials.map((item) => {
      const decoded = { ...item };
      tokenFields.forEach((field) => {
        decoded[field] = decodeIfJwt(item[field]);
      });
      return decoded;
    });
  };
  const initialize = async () => {
    dispatch(loadingOn());
    try {
      const credentials = await getAllToteat(company?._id);

      if (credentials) {
        const credentialsList = [];

        subsidiaries?.forEach((s) => {
          const subsidiaryCredential = credentials?.find(
            (c) => c?.subsidiaryId === s?._id
          );
          if (subsidiaryCredential) {
            credentialsList.push(subsidiaryCredential);
          } else {
            setNewTokensFlag(true);
            credentialsList.push({
              restaurantId: "",
              localId: "",
              userId: "",
              token: "",
              paymentType: "",
              paymentTypes: {},
              companyId: s?.CompanyId,
              subsidiaryId: s?._id,
              isTest: false,
              useMockOrder: false,
              useAdditionalReferenceTitle: false,
              mockProductCode: "",
              isNew: true,
              useFailedShippingNotification: false,
              productCodeForFailedShippingNotification: "",
              useShippingCost: false,
              productCodeForShippingCost: "",
              useFee: false,
              productCodeForFee: "",
              useBillPayment: false,
              paymentCodeForBillPayment: "",
            });
          }
        });
        const decodedList = decodeCredentials(credentialsList);

        setToteatCredentials(decodedList);
      }
    } catch (error) {
      console.log("error toteat", error);
    } finally {
      dispatch(loadingOff());
    }
  };
  const credential = useMemo(
    () => toteatCredentials.find((c) => c.subsidiaryId === subsidiaryId),
    [toteatCredentials, subsidiaryId, company, subsidiaries]
  );

  const trackFieldChange = (field, oldValue, newValue, subsidiaryId) => {
    if (oldValue === newValue) return; // no change

    const logs = [...changes];

    const existing = logs.find(
      (l) => l.field === field && l?.subsidiaryId === subsidiaryId
    );
    const selectedSubsidiary = subsidiaries?.find(
      (f) => f?._id === subsidiaryId
    );

    const newLog = {
      field,
      text: `Cambió el campo ${field} para ${selectedSubsidiary ? selectedSubsidiary?.Name : "Todas las sucursales"
        }`,
      oldValue: existing ? existing.oldValue : oldValue,
      newValue,
      date: new Date().toISOString(),
      subsidiaryId,
    };

    if (existing) {
      const index = logs.findIndex((l) => l.field === field);
      logs[index] = newLog;
    } else {
      logs.push(newLog);
    }

    dispatch(setChanges(logs));
  };

  const handleChanges = (selectedCredential, property, value, subsidiaryId) => {
    setToteatCredentials((prev) => {
      const updated = prev.map((cred) => {
        if (cred?.subsidiaryId === selectedCredential?.subsidiaryId) {
          if (!cred?.isNew) {
            setTokenModifiedFlag(true);
          }
          return {
            ...cred,
            [property]: value,
            modified: true,
          };
        }

        return cred;
      });
      return updated;
    });

    trackFieldChange(
      property,
      typeof selectedCredential?.[property] === "boolean"
        ? !selectedCredential?.[property]
          ? "Activo"
          : "Inactivo"
        : selectedCredential?.[property],
      typeof value === "boolean" ? (value ? "Activo" : "Inactivo") : value,
      subsidiaryId
    );
    setUpdated(true);
  };

  const handleCancel = () => initialize();

  const createNewToteatTokens = async () => {
    const modifiedCredentials = toteatCredentials
      .filter((cred) => cred.isNew)
      .map(({ modified, isNew, ...rest }) => rest);

    try {
      const results = await Promise.all(
        modifiedCredentials.map((cred) =>
          createToteat({
            restaurantId: jwt.sign(cred.restaurantId, config.jwtSecret),
            localId: jwt.sign(cred.localId, config.jwtSecret),
            userId: jwt.sign(cred.userId, config.jwtSecret),
            token: jwt.sign(cred.token, config.jwtSecret),
            paymentType: cred.paymentType ? jwt.sign(cred.paymentType, config.jwtSecret) : undefined,
            paymentTypes: cred.paymentTypes ?? undefined,
            companyId: cred.companyId || company._id,
            subsidiaryId: cred.subsidiaryId,
            isTest: cred.isTest,
            useMockOrder: cred.useMockOrder,
            useAdditionalReferenceTitle: cred.useAdditionalReferenceTitle,
            mockProductCode: cred.mockProductCode,
            useFailedShippingNotification: cred.useFailedShippingNotification,
            productCodeForFailedShippingNotification:
              cred.productCodeForFailedShippingNotification,
            useShippingCost: cred.useShippingCost,
            productCodeForShippingCost: cred.productCodeForShippingCost,
            useFee: cred.useFee,
            productCodeForFee: cred.productCodeForFee,
            useBillPayment: cred.useBillPayment,
            paymentCodeForBillPayment: cred.paymentCodeForBillPayment,
          })
        )
      );
      return results;
    } catch (error) {
      console.log("error tryint to create new tokens", error);
      enqueueSnackbar(
        Notification({
          text: `Error tratando de crear nuevos tokens`,
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      setNewTokensFlag(false);
    }
  };

  const changeToteatTokens = async () => {
    const modifiedCredentials = toteatCredentials
      .filter((cred) => cred.modified && !cred.isNew)
      .map(({ modified, isNew, ...rest }) => rest);

    try {
      const results = await Promise.all(
        modifiedCredentials.map((cred) =>
          updateToteat({
            restaurantId: jwt.sign(cred.restaurantId, config.jwtSecret),
            localId: jwt.sign(cred.localId, config.jwtSecret),
            userId: jwt.sign(cred.userId, config.jwtSecret),
            token: jwt.sign(cred.token, config.jwtSecret),
            paymentType: cred.paymentType ? jwt.sign(cred.paymentType, config.jwtSecret) : undefined,
            paymentTypes: cred.paymentTypes ?? undefined,
            companyId: cred.companyId || company._id,
            subsidiaryId: cred.subsidiaryId,
            isTest: cred.isTest,
            useMockOrder: cred.useMockOrder,
            useAdditionalReferenceTitle: cred.useAdditionalReferenceTitle,
            mockProductCode: cred.mockProductCode,
            useFailedShippingNotification: cred.useFailedShippingNotification,
            productCodeForFailedShippingNotification:
              cred.productCodeForFailedShippingNotification,
            useShippingCost: cred.useShippingCost,
            productCodeForShippingCost: cred.productCodeForShippingCost,
            useFee: cred.useFee,
            productCodeForFee: cred.productCodeForFee,
            useBillPayment: cred.useBillPayment,
            paymentCodeForBillPayment: cred.paymentCodeForBillPayment,
          })
        )
      );
      return results;
    } catch (error) {
      console.log("error trying to create new tokens", error);
      enqueueSnackbar(
        Notification({
          text: `Error tratando de crear nuevos tokens`,
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      setTokenModifiedFlag(false);
    }
  };

  const handleSave = async () => {
    dispatch(loadingOn());
    try {
      if (newTokensFlag) {
        await createNewToteatTokens();
      }
      if (tokenModifiedFlag) {
        await changeToteatTokens();
      }
      await recordChange({
        module: "POS",
        submodule: "Toteat",
        changes,
      });
      enqueueSnackbar(
        Notification({
          text: "Datos de la tienda actualizados",
          variant: "success",
          withDetails: false,
        })
      );
    } catch (error) {
      enqueueSnackbar(
        Notification({
          text: "Error al actualizar datos de la tienda",
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      setUpdated(false);
      getCompany(company._id, dispatch);
      await initialize();

      dispatch(loadingOff());
    }
  };

  const handleRemove = async (subId) => {
    dispatch(loadingOn());
    deleteToteat(company._id, subId)
      .then(async (res) => {
        dispatch(loadingOff());
        getCompany(company._id, dispatch);
        await initialize();
        enqueueSnackbar(
          Notification({
            text: "Datos de la tienda actualizados",
            variant: "success",
            withDetails: false,
          })
        );
        setUpdated(false);
        await recordChange({
          module: "POS",
          submodule: "Toteat",
          changes: [
            {
              field: "Servicio de toteat",
              text: "Eliminación de credenciales",
              oldValue: "Credenciales registradas",
              newValue: "Credenciales eliminadas",
              date: new Date().toISOString(),
            },
          ],
        }).catch((err) => console.log(err));
      })
      .catch((err) => {
        enqueueSnackbar(
          Notification({
            text: "Error al actualizar datos de la tienda",
            variant: "error",
            withDetails: false,
          })
        );
        dispatch(loadingOff());
      });
  };

  const handleClose = () => {
    navigate(-1);
  };

  const isFormValid = useMemo(() => {
    if (!Array.isArray(toteatCredentials) || toteatCredentials.length === 0)
      return false;

    return toteatCredentials.every(
      ({ restaurantId, localId, userId, token, paymentType, paymentTypes }) => {
        const baseFieldsValid = [restaurantId, localId, userId, token].every(
          (field) => typeof field === "string" && field.trim() !== ""
        );
        const hasPaymentType = typeof paymentType === "string" && paymentType.trim() !== "";
        const hasPaymentTypes = paymentTypes && Object.values(paymentTypes).some((v) => v !== undefined && v !== null && v !== "");
        return baseFieldsValid && (hasPaymentType || hasPaymentTypes);
      }
    );
  }, [toteatCredentials]);

  useEffect(() => {
    if (subsidiaries && subsidiaries.length > 0 && !subsidiaryId)
      setSubsidiaryId(subsidiaries[0]._id);
  }, [subsidiaries]);

  useEffect(() => {
    if (company?._id && subsidiaries?.length > 0) {
      initialize();
    }
  }, [company?._id, subsidiaries]);

  return (
    <div className={styles.parentContainer}>
      <div className={styles.changeLogsContainer}>
        <button className={styles.backButton} onClick={() => handleClose()}>
          <span>
            <ArrowBackIcon />
          </span>
          Regresar
        </button>

        <ChangeLogs
          {...{
            module: "POS",
            submodule: "Toteat",
            subtitle: (
              <span>
                Historial de modfificación de credenciales de{" "}
                <strong>Toteat</strong>
              </span>
            ),
          }}
        />
      </div>

      <div className={styles.infoContainer}>
        <div className={styles.titleLogoContainer}>
          <img src={logo} alt="logo" className={styles.imageElement} />
          <div className={styles.titleDescriptionContainer}>
            <Toolbar title="Toteat" />
            <p className={styles.textDescription}>
              Con las credenciales de TOTEAT podrás integrar tu sistema
              administrativo de restaurante en uno solo. Esto significa que los
              pedidos que recibas a través de NubeFood serán recibidos
              automáticamente en tu sistema TOTEAT, permitiéndote tener un
              control centralizado de todas las ventas diarias, así como también
              la generación de una boleta por cada pedido
            </p>
          </div>
        </div>
        <Alert
          severity="info"
          className={styles.alertMessageTable}
          classes={{ message: styles.alertMessageTable }}
          style={{ alignItems: "center" }}
        >
          <div className={styles.errorPOSContainer}>
            <p className={styles.errorPOSTitle}>
              Asegurate de tener las credenciales correctas de TOTEAT antes de
              continuar. Puedes obtenerlas desde tu panel de administración de
              TOTEAT.
            </p>
          </div>
        </Alert>
        <div className={styles.infoDataContainer}>
          {subsidiaries?.length > 1 && (
            <ScrollBar
              value={subsidiaryId}
              onChange={(newValue) => setSubsidiaryId(newValue)}
              list={subsidiaries}
              useCustomStyles={true}
              customStyles={{
                wrapper: styles.wrapperclass,
                tabList: styles.tabListClass,
                tabItem: styles.tabItemClass,
                activeTab: styles.activeTabClass,
              }}
            />
          )}
          <div className={styles.inputStackContainer}>
            {/* Card: Credenciales */}
            <div className={styles.sectionCard}>
              <div className={styles.credentialsGrid}>
                <div className={styles.inputContainer}>
                  <label className={styles.labelInput}>Restaurant ID</label>
                  <input
                    key={`restaurantId-${credential?.subsidiaryId}`}
                    placeholder="Ej. 12345678901234"
                    type="text"
                    onChange={(e) => {
                      handleChanges(credential, "restaurantId", e.target.value, subsidiaryId);
                    }}
                    disabled={loading || !credential}
                    value={credential?.restaurantId}
                    className={styles.inputElement}
                  />
                </div>
                <div className={styles.inputContainer}>
                  <label className={styles.labelInput}>Local ID</label>
                  <input
                    key={`localId-${credential?.subsidiaryId}`}
                    placeholder="Ej. 12345678901234"
                    type="text"
                    onChange={(e) => {
                      handleChanges(credential, "localId", e.target.value, subsidiaryId);
                    }}
                    disabled={loading || !credential}
                    className={styles.inputElement}
                    value={credential?.localId}
                  />
                </div>
                <div className={styles.inputContainer}>
                  <label className={styles.labelInput}>User ID</label>
                  <input
                    key={`userId-${credential?.subsidiaryId}`}
                    placeholder="Ej. 12345678901234"
                    type="text"
                    onChange={(e) => {
                      handleChanges(credential, "userId", e.target.value, subsidiaryId);
                    }}
                    disabled={loading || !credential}
                    className={styles.inputElement}
                    value={credential?.userId}
                  />
                </div>
                <div className={styles.inputContainer}>
                  <label className={styles.labelInput}>Token</label>
                  <input
                    key={`token-${credential?.subsidiaryId}`}
                    placeholder="Ej. 12345678901234"
                    type="text"
                    onChange={(e) => {
                      handleChanges(credential, "token", e.target.value, subsidiaryId);
                    }}
                    disabled={loading || !credential}
                    className={styles.inputElement}
                    value={credential?.token}
                  />
                </div>
                <div className={styles.inputContainer}>
                  <label className={styles.labelInput}>Payment Type (general)</label>
                  <input
                    key={`paymentType-${credential?.subsidiaryId}`}
                    placeholder="Ej. 5000"
                    type="number"
                    onChange={(e) => {
                      handleChanges(credential, "paymentType", e.target.value, subsidiaryId);
                    }}
                    disabled={loading || !credential}
                    className={styles.inputElement}
                    value={credential?.paymentType}
                  />
                </div>
              </div>
              <Accordion className={styles.paymentTypesAccordion} elevation={0}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <label className={styles.labelInput} style={{ margin: 0 }}>
                    Payment Type por método de pago
                  </label>
                  <span className={styles.accordionHint}>
                    Opcional, sobrescribe el general
                  </span>
                </AccordionSummary>
                <AccordionDetails className={styles.paymentTypesGrid}>
                  {[
                    { key: "webpay", label: "Webpay", flag: "useWebpay" },
                    { key: "mercadopago", label: "Mercadopago", flag: "useMercadopago" },
                    { key: "getnet", label: "Getnet", flag: "useGetnet" },
                    { key: "fintoc", label: "Fintoc", flag: "useFintoc" },
                    { key: "edenred", label: "Edenred", flag: "useEdenred" },
                    { key: "amipass", label: "Amipass", flag: "useAmipass" },
                  ].filter(({ flag }) => company?.UsePayments?.[flag]).map(({ key, label }) => (
                    <div className={styles.inputContainer} key={`paymentTypes-${key}-${credential?.subsidiaryId}`}>
                      <label className={styles.labelInput}>{label}</label>
                      <input
                        placeholder="Ej. 5000"
                        type="number"
                        onChange={(e) => {
                          const value = e.target.value === "" ? undefined : Number(e.target.value);
                          const newPaymentTypes = { ...(credential?.paymentTypes || {}), [key]: value };
                          setToteatCredentials((prev) =>
                            prev.map((cred) => {
                              if (cred?.subsidiaryId === credential?.subsidiaryId) {
                                if (!cred?.isNew) setTokenModifiedFlag(true);
                                return { ...cred, paymentTypes: newPaymentTypes, modified: true };
                              }
                              return cred;
                            })
                          );
                          trackFieldChange(
                            `paymentType (${label})`,
                            credential?.paymentTypes?.[key] ?? "-",
                            value ?? "-",
                            subsidiaryId
                          );
                          setUpdated(true);
                        }}
                        disabled={loading || !credential}
                        className={styles.inputElement}
                        value={credential?.paymentTypes?.[key] ?? ""}
                      />
                    </div>
                  ))}
                </AccordionDetails>
              </Accordion>
            </div>

            {/* Card: Opciones */}
            <div className={styles.sectionCard}>
              <label className={styles.sectionTitle}>Opciones adicionales</label>
              <div className={styles.optionsGrid}>
              <div className={styles.inputContainerCheckbox}>
              <input
                type="checkbox"
                key={`restaurantId-${credential?.subsidiaryId}`}
                checked={credential?.isTest}
                onChange={(e) => {
                  handleChanges(credential, "isTest", e.target.checked);
                }}
                value={"isTest"}
                disabled={loading || !credential}
              />
              <label className={styles.labelInput}>Activar modo prueba</label>
            </div>
            <div className={styles.inputContainerCheckbox}>
              <input
                type="checkbox"
                key={`restaurantId-${credential?.subsidiaryId}`}
                checked={credential?.useAdditionalReferenceTitle}
                onChange={(e) => {
                  handleChanges(
                    credential,
                    "useAdditionalReferenceTitle",
                    e.target.checked
                  );
                }}
                value={"useAdditionalReferenceTitle"}
                disabled={loading || !credential}
              />
              <label className={styles.labelInput}>
                Activar grupo de adicionales en comanda
              </label>
            </div>
            <div className={styles.inputContainerCheckbox}>
              <input
                type="checkbox"
                key={`restaurantId-${credential?.subsidiaryId}`}
                checked={credential?.useMockOrder}
                onChange={(e) => {
                  handleChanges(credential, "useMockOrder", e.target.checked);
                }}
                value={"useMockOrder"}
                disabled={loading || !credential}
                style={{ alignSelf: "baseline" }}
              />
              <div className={styles.insideInputContainer}>
                <label className={styles.labelInput}>
                  Crear orden provisional cuando se recibe un pedido con
                  productId erróneo
                </label>
                {credential?.useMockOrder ? (
                  <div className={styles.inputContainer}>
                    <label className={styles.labelInput}>
                      ProductCode para orden provisional
                    </label>
                    <input
                      key={`restaurantId-${credential?.subsidiaryId}`}
                      className={styles.inputElement}
                      placeholder="Ej. 12345678901234"
                      type="text"
                      onChange={(e) => {
                        handleChanges(
                          credential,
                          "mockProductCode",
                          e.target.value,
                          subsidiaryId
                        );
                      }}
                      disabled={loading || !credential}
                      validation={credential?.mockProductCode === ""}
                      value={credential?.mockProductCode}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.inputContainerCheckbox}>
              <input
                type="checkbox"
                key={`restaurantId-${credential?.subsidiaryId}`}
                checked={credential?.useFailedShippingNotification}
                onChange={(e) => {
                  handleChanges(
                    credential,
                    "useFailedShippingNotification",
                    e.target.checked
                  );
                }}
                value={"useFailedShippingNotification"}
                disabled={loading || !credential}
                style={{ alignSelf: "baseline" }}
              />
              <div className={styles.insideInputContainer}>
                <label className={styles.labelInput}>
                  Crear orden de error de envío
                </label>
                {credential?.useFailedShippingNotification ? (
                  <div className={styles.inputContainer}>
                    <label className={styles.labelInput}>
                      ProductCode para orden de error de envío
                    </label>
                    <input
                      key={`restaurantId-${credential?.subsidiaryId}`}
                      className={styles.inputElement}
                      placeholder="Ej. 12345678901234"
                      type="text"
                      onChange={(e) => {
                        handleChanges(
                          credential,
                          "productCodeForFailedShippingNotification",
                          e.target.value,
                          subsidiaryId
                        );
                      }}
                      disabled={loading || !credential}
                      validation={
                        credential?.productCodeForFailedShippingNotification ===
                        ""
                      }
                      value={
                        credential?.productCodeForFailedShippingNotification
                      }
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.inputContainerCheckbox}>
              <input
                type="checkbox"
                key={`shippingCost-${credential?.subsidiaryId}`}
                checked={credential?.useShippingCost}
                onChange={(e) => {
                  handleChanges(
                    credential,
                    "useShippingCost",
                    e.target.checked,
                    subsidiaryId
                  );
                }}
                value={"useShippingCost"}
                disabled={loading || !credential}
                style={{ alignSelf: "baseline" }}
              />
              <div className={styles.insideInputContainer}>
                <label className={styles.labelInput}>
                  Usar costo de envío en la orden
                </label>
                {credential?.useShippingCost ? (
                  <div className={styles.inputContainer}>
                    <label className={styles.labelInput}>
                      ProductCode para costo de envío
                    </label>
                    <input
                      key={`shippingCostCode-${credential?.subsidiaryId}`}
                      className={styles.inputElement}
                      placeholder="Ej. 12345678901234"
                      type="text"
                      onChange={(e) => {
                        handleChanges(
                          credential,
                          "productCodeForShippingCost",
                          e.target.value,
                          subsidiaryId
                        );
                      }}
                      disabled={loading || !credential}
                      validation={
                        credential?.productCodeForShippingCost === ""
                      }
                      value={credential?.productCodeForShippingCost}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.inputContainerCheckbox}>
              <input
                type="checkbox"
                key={`useFee-${credential?.subsidiaryId}`}
                checked={credential?.useFee}
                onChange={(e) => {
                  handleChanges(
                    credential,
                    "useFee",
                    e.target.checked,
                    subsidiaryId
                  );
                }}
                value={"useFee"}
                disabled={loading || !credential}
                style={{ alignSelf: "baseline" }}
              />
              <div className={styles.insideInputContainer}>
                <label className={styles.labelInput}>
                  Usar cuota de servicio en la orden
                </label>
                {credential?.useFee ? (
                  <div className={styles.inputContainer}>
                    <label className={styles.labelInput}>
                      ProductCode para cuota de servicio
                    </label>
                    <input
                      key={`productCodeForFee-${credential?.subsidiaryId}`}
                      className={styles.inputElement}
                      placeholder="Ej. 12345678901234"
                      type="text"
                      onChange={(e) => {
                        handleChanges(
                          credential,
                          "productCodeForFee",
                          e.target.value,
                          subsidiaryId
                        );
                      }}
                      disabled={loading || !credential}
                      validation={
                        credential?.productCodeForFee === ""
                      }
                      value={credential?.productCodeForFee}
                    />
                  </div>
                ) : null}
              </div>

            </div>
            <div className={styles.inputContainerCheckbox}>
              <input
                type="checkbox"
                key={`useBillPayment-${credential?.subsidiaryId}`}
                checked={credential?.useBillPayment}
                onChange={(e) => {
                  handleChanges(
                    credential,
                    "useBillPayment",
                    e.target.checked,
                    subsidiaryId
                  );
                }}
                value={"useBillPayment"}
                disabled={loading || !credential}
                style={{ alignSelf: "baseline" }}
              />
              <div className={styles.insideInputContainer}>
                <label className={styles.labelInput}>
                  Usar método de pago en la factura <span style={{ color: "red" }}>{!company?.useCheckoutInvoiceModal ? "(Para usar esta opción debe activar en configuraciones `Permitir al cliente/comprador que pueda solicitar una factura` )" : ""}</span>
                </label>
                {credential?.useBillPayment ? (
                  <div className={styles.inputContainer}>
                    <label className={styles.labelInput}>
                      Código de método de pago en la factura
                    </label>
                    <input
                      key={`paymentCodeForBillPayment-${credential?.subsidiaryId}`}
                      className={styles.inputElement}
                      placeholder="Ej. 12345678901234"
                      type="number"
                      onChange={(e) => {
                        handleChanges(
                          credential,
                          "paymentCodeForBillPayment",
                          e.target.value,
                          subsidiaryId
                        );
                      }}
                      disabled={loading || !credential}
                      validation={
                        credential?.paymentCodeForBillPayment === ""
                      }
                      value={credential?.paymentCodeForBillPayment}
                    />
                  </div>
                ) : null}
              </div>

            </div>
              </div>
            </div>
            {credential?.token !== "" ? (
              <div className={styles.btnContainerDeleteCredential}>
                <button
                  onClick={() => {
                    handleRemove(credential?.subsidiaryId);
                  }}
                  className={classNames(styles.baseBtn, styles.deleteButton)}
                >
                  Eliminar credenciales
                </button>
                <p className={styles.underLabel}>
                  *Solo se eliminaran las credenciales de la sucursal
                  seleccionada
                </p>
              </div>
            ) : null}
            <div className={styles.lineDivisor}></div>
            <div className={styles.btnContainerWithLabel}>
              <div className={styles.buttonsContainer}>
                <button
                  disabled={!updated}
                  onClick={() => {
                    setUpdated(true);
                    handleCancel();
                  }}
                  className={classNames(styles.baseBtn, styles.cancelButton)}
                >
                  Cancelar
                </button>
                <button
                  disabled={!updated || !isFormValid}
                  className={classNames(styles.baseBtn, styles.confirmButton)}
                  onClick={() => {
                    setUpdated(true);
                    handleSave();
                  }}
                >
                  Guardar
                </button>
              </div>
              {!isFormValid && (
                <p className={styles.underLabelRed}>
                  Todas las sucursales deben tener credenciales para guardar.{" "}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
